import { render, staticRenderFns } from "./EventEditorSlotGroups.vue?vue&type=template&id=621cc551&lang=pug&"
import script from "./EventEditorSlotGroups.vue?vue&type=script&lang=ts&"
export * from "./EventEditorSlotGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
